import { Component, OnInit } from '@angular/core';
// import { Router, ActivatedRoute, Params} from '@angular/router';
import { Observable, Subject} from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { BootstrapRelayService } from '../../services/bootstrap-relay.service';
import { FlashService } from '../../services/utility/flash.service';
import { User } from '../../models/User';
// import { SettingsService } from '../../services/settings.service';
import { Http } from '@angular/http';
import { HttpHelperService } from "../../services/utility/http-helper.service";



@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  user: User;  //only assigned if valid token
  showRegister:boolean;
  colors = [ "white", "papayawhip", "oldlace", "snow", "ghostwhite", "linen", "seashell", "mintcream" ]
  isInitialized:boolean = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private brs:BootstrapRelayService,
    private flashService:FlashService,
    private http:Http,
    private httpHelperService:HttpHelperService,
    
    
    // private settingsService:SettingsService,
    // private route:ActivatedRoute,
    // private router:Router
  ) { 
    // this.route.params.subscribe();
  }

  ngOnInit() {
    // this.user = this.authService.getLoggedInUser() as User;
    this.authService.user$
    .takeUntil(this.ngUnsubscribe)
    .subscribe((user) => {

      if (!user && this.user){
        //user logged out
        // console.log('navbar observed this.user '+this.user+' is logging out due to nextUser '+user);
        this.user = user;
        this.flashService.flashMessage.show('You are logged out', {cssClass:'alert-success', timeout: 4000});
      }
    })
    // console.log('navbar this.user', this.user);

    //handle user change => modal hidden
    this.brs.registerEvent('hidden.bs.modal');

    // hidden.bs.modal occurs, and afterward we assign the logged in user to local var.


    //restore a previously loggedInUser if possible
    this.authService.restorePreviousLogin();
    //  this.isInitialized == true;
    this.authService.user$
    .first()
    .subscribe((user) => {
      // console.log('navbar "first" observed a user change.  *this should only execute once');
      this.user = user;
    });


    //Perfect!  Observes a stream of 'hidden.bs.modal' events.  Upon executing one, 
    // it observes this.authService.user$ exactly one time (.first()) at the moment of the hidden event.
    Observable.fromEvent(document, 'hidden.bs.modal')
    .flatMap(
      event => {
        return this.authService.user$.first();
      }
    ).subscribe(
      user => {
        // console.log('combinedValue of hidden.bs.modal and this.authService.user$', user);
        this.user = user;
      }
    )

  }



  //navbar is an observer of user$, and will display flash message announcing logout
  // let user$ subscription set user to null.
  // see ngOnInit above.
  onLogoutClick($event){
    $event.preventDefault();  //don't navigate away from current page
    this.authService.logoutUser();
    this.router.navigate(['/']);
  }

  //TEST API ONLY
  onRunApiTestClick($event){
    console.log("running api test...");
    this.http_testApi().then((text) => {
      console.log(text);
    });

  }

  http_testApi():Promise<string> {      
    console.log(window.location.hostname);
    // let hostname = window.location.hostname;
    // let baseurl = hostname == "localhost" ? "http://" : "https://";
    let apipath = '/api/products/detail/1010';
    let apiurl = this.httpHelperService.urlFromPath(apipath);  //baseurl + hostname + producturl
    return this.http.get(apiurl)
      .map(res => res.text() )
      .toPromise();
}

  setBackground(event, color){
    //access DOM to modify background of the content wrapper
    let containerElement: HTMLElement = document.getElementsByClassName('container content wrapper')[0] as HTMLElement;
    containerElement.style.background = color;
    // console.log(containerElement.style.background);
  }
  
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}



// async function asyncAwait() {
//   console.log("Knock, knock!");
//   this.flashMessagesService.show('You are logged in', { cssClass: 'alert-success', timeout: 4000 });
  
//   await delay(3000);
//   console.log("Who's there?");

//   await delay(1000);
//   console.log("async/await!");
// }


// function delay(ms: number) {
//   return new Promise<void>(function(resolve) {
//       setTimeout(resolve, ms);
//   });
// }

  // checkLogin(){
  //   //check if user is logged in.  If so grab the email.
  //   this.tokenValid = this.authService.checkLoggedIn()
  //   // console.log('this.tokenValid', this.tokenValid);
  //   if(this.tokenValid){
  //     let user = this.authService.getLoggedInUser() as User;
  //     // console.log('user', user);
  //     this.user = user;
  //   }
  // }

  // this.route.params.subscribe((params: Params) => {
  //   console.log('navbar: params', params);
  //   console.log('navbar: params.category:', params["category"]);
  // });


    // //upon loging, update with user  -- no!  updates UI and prevents flash-message about user logging in from showing.
    // this.authService.didLogInUser.subscribe(user => {
    //   this.user = user;
    // });

        // //upon logout, show message
    // this.authService.didLogOutUser.subscribe(user => {
    //   // console.log('navbar noticed user logging out', user);
    //   this.flashMessagesService.show('You are logged out', {cssClass:'alert-success', timeout: 4000});
    // });

        // //handle user change => modal hidden
    // this.brs.registerEvent('hidden.bs.modal');
    // let userchange$ = this.authService.user$;
    // let hiddenAfterUserChange$ = userchange$.switchMap((user) => {
    //   console.log('inside the switchmap')
    //   return Observable.fromEvent(document, 'hidden.bs.modal');
    // });

    // hiddenAfterUserChange$.subscribe(() => {
    //   console.log('inside the subscribe');
    //   this.user = this.authService.user$.value;
    // });
        

    // var clicks = Rx.Observable.fromEvent(document, 'click');
    // var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
    // result.subscribe(x => console.log(x));

    // //upon login, must not assign this.user until after the modal is hidden.
    // this.brs.registerEvent('hidden.bs.modal');
    // Observable.fromEvent(document, 'hidden.bs.modal')
    // .subscribe(($event) => {
    //   console.log('navbar observed hidden.bs.modal');
    //   this.user = this.authService.user$.value;
    //   //nav-signin tracks user logging in, so it will display the flash message.
    //   //  only way to track flash message here is to chain the observable for user$ to the observable for hidden.bs.modal.
    // });


    // //this works, but is dependent on the modal animation
    // Observable.fromEvent(document, 'hidden.bs.modal')
    // .subscribe(() => {
    //   this.user = this.authService.user$.value;
    // });

        // // this works, and is not dependent on the modal animation.
    // Observable.fromEvent(document, 'hidden.bs.modal').switchMap((event) => {
    //   console.log('inside the switchmap with event', event);
    //   return this.authService.user$;
    // })
    // .subscribe((user) => {
    //   //is called on every user change, but will wait if hidden.bs.modal is detected
    //   console.log('inside the subscribe with user', user);
    //   this.user = user;
    // });


    //Note - I did additional testing on switchmap.  I couldn't get obs2 (user change) to wait until obs1 (hidden event) occurs.
    // The subscribe code was executing when obs2 occured without a prior obs1.
          // // tested this, it does NOT work as expected.
      // // NOTE! this assigns user BEFORE the hodden.bs.modal event.
      //   //  **you must start with the hidden event, THEN switchmap the modal.
      // this.authService.user$
      // .switchMap((user) => {
      //   this.user = this.authService.user$.value;
      //   return Observable.fromEvent(document, 'hidden.bs.modal')
      // })
      // .subscribe(() => {
                
      // });
  

    //TESTING SWITCHMAP.  Note that it waits for observable1 to complete before continuing to observable2.
    // function simulateHttp(val: any, delay:number) {
    //   return Observable.of(val).delay(delay);
    // }
    // const saveUser$ = simulateHttp(" user saved ", 1000);
    // const httpResult$ = saveUser$.switchMap(sourceValue => {
    //     console.log(sourceValue);
    //     return simulateHttp(" data reloaded ", 2000);
    // });
    // httpResult$.subscribe(
    //     console.log,
    //     console.error,
    //     () => console.log('completed httpResult$')
    // );

  //No!  this isn't what we want.  See below explanation.
      //  this.authService.user$
  //   .switchMap((user) => {
  //    console.log('navbar observed user change', user);
  //   return Observable.fromEvent(document, 'hidden.bs.modal'); 
  //   })
  //   .takeWhile(() => this.isInitialized == false)
  //   .subscribe((event) => {
  //     console.log('navbar observed hidden.bs.modal'); 
  //   })


    // //NO! - this doesn't make sense.  Basically flatMap and switchMap will pass the 'result' of Obs1 into Obs2.  
    // // The difference is that SwitchMap will cancel Obs2 subscription and replace it with a NEW Obs2.
    // //  So that means the code below will START observing users once hidden event occurs, 
    // //  and Upon each new Hidden, it will 'resubscribe' to user changes again.  However this is not what we want.
    // //  We want to wait for hidden.bs.modal and THEN grab the current user (not start a subscription to it, 
    // //  because starting the subscription will not make obs2 dependent on obs1 occuriing chonologically FIRST).
    // //  *you could perhaps use .first() on obs2 the username so that it only fires once per obs1, but might as well
    // //   just grab the value from this.authService.user$.value.
    // //  To sum up, our goal is: 1. hidden.bs.modal occurs, and afterward we assign the logged in user to local var.
    // Observable.fromEvent(document, 'hidden.bs.modal').switchMap((event) => {
    //   console.log('inside the switchmap with event', event);
    //   return this.authService.user$;
    // })
    // .subscribe((user) => {
    //   //is called on every user change, but will wait if hidden.bs.modal is detected
    //   console.log('inside the subscribe with user', user);
    //   this.user = user;
    // });


        // // this works, and is not dependent on the modal animation.
        // But I found a 'better' way involving switchmap, which I can later use on chaining or cancelling http requests.
    // Observable.fromEvent(document, 'hidden.bs.modal')
    // .subscribe((event) => {
    //   console.log('navbar observed hidden.bs.modal.');
    //   let currentUser = this.authService.user$.value;
    //   if (this.user != currentUser){
    //     console.log('saving user');
    //     this.user = currentUser;
    //   }
    // });


    // NO.  While this DOES ensure subscribe happens only upon Obs2, putting obs2.first or obs1.first will only allow one emission of value.
    //  Instead, what you want is for detection of user change, and then 
    // this.authService.user$
    // .takeUntil(this.ngUnsubscribe)
    // .mergeMap(
    //   user => {
    //     return Observable.fromEvent(document, 'hidden.bs.modal').first().map(event => {
    //       return user;
    //     });
    //   }
    // ).subscribe(
    //   user => {
    //     console.log('combinedValue of this.authService.user$ and hidden.bs.modal', user);
    //     this.user = user;
    //   }
    // )
        // console.log('navbar: observed change in user', user);
      //if user was not null, and is now being nulled out...
      // console.log('this.user', this.user);
      // console.log('user', user);


// WEBPACK FOOTER //
// ./src/app/components/navbar/navbar.component.ts